<template>
  <div class="footer">
    <!-- <div class="footer-top clearfix container">
      <span class="footer-top-name fl">上海市疾病预防控制中心</span>
      <span class="footer-top-type fl">学术馆</span>
      <span class="footer-top-num fr">网站总浏览量：2301次</span>
    </div> -->
    <div class="footer-cen container">
      <!-- <span class="footer-cen-eng">技术支持：杭州博库科技有限公司</span> -->

      <!-- <span class="footer-cen-info">Copyright(c) 2009-2010 上海市疾病预防控制中心 版权所有 备案序号：浙ICP备05071789号  浙公网安备 33010402001924号</span> -->
      <span class="footer-cen-info" v-if="$route.path=='/home'">版权所有 华慧科技 &copy;2021 <a href="https://beian.miit.gov.cn/" target="_blank">浙ICP13035740号-2</a></span>
    </div>
    <div class="footer-bot container"></div>
  </div>
</template>

<script>
export default {
  name: "btm-footer",
};
</script>

<style scoped lang="less">
.footer {
  background: #f6f6f6;
  color: #fff;
  text-align: center;
  height: 120px;
  padding-top: 48px;
  box-sizing: border-box;
  .footer-top {
    .footer-top-name {
      font-size: 36px;
      font-weight: 400;
      line-height: 50px;
      color: #035bad;
      margin-right: 27px;
    }
    .footer-top-type {
      font-size: 24px;
      font-weight: 400;
      line-height: 60px;
      color: #035bad;
    }
    .footer-top-num {
      color: #707070;
      line-height: 60px;
    }
  }
  .footer-cen {
    text-align: center;
    span {
      display: block;
    }
    .footer-cen-eng {
      // color: #035BAD;
      color: #707070;
      margin-bottom: 9px;
    }
    .footer-cen-info {
      color: #707070;
      margin-left: auto;
      a{
        color: #2440b3;
        &:hover{
          text-decoration: underline;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/btm-footer.vue